"use strict";
//
// Copyright © 2024 Hardcore Engineering Inc.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectUrl = exports.hashWorkspace = void 0;
exports.encodeDocumentId = encodeDocumentId;
exports.decodeDocumentId = decodeDocumentId;
// Re-export from core for backward compatibility
var core_1 = require("@hcengineering/core");
Object.defineProperty(exports, "hashWorkspace", { enumerable: true, get: function () { return core_1.hashWorkspace; } });
Object.defineProperty(exports, "selectUrl", { enumerable: true, get: function () { return core_1.selectUrl; } });
/** @public */
function encodeDocumentId(workspaceId, documentId) {
    const { objectClass, objectId, objectAttr } = documentId;
    return [workspaceId, objectClass, objectId, objectAttr].join('|');
}
/** @public */
function decodeDocumentId(documentId) {
    const [workspaceId, objectClass, objectId, objectAttr] = documentId.split('|');
    return {
        workspaceId,
        documentId: {
            objectClass: objectClass,
            objectId: objectId,
            objectAttr
        }
    };
}
//# sourceMappingURL=utils.js.map